module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addToCart
    }
  }, [_c('i', {
    staticClass: "fa fa-cart-plus"
  }), _vm._v(" Add to Cart")]) : _c('span', [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb914144"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductCartActions.vue
// module id = 308
// module chunks = 0